var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RouterLink',{staticClass:"cursor-pointer rounded text-slate-700",attrs:{"to":_vm.to,"exact":"","active-class":"decoration-2 underline-offset-6"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }